import React from 'react';

interface FormProps {
  className?: string;
  onSubmit?: () => void;
}

export const Form = ({
  children,
  className,
  onSubmit,
}: React.PropsWithChildren<FormProps>) => (
  <form
    className={className}
    onSubmit={(event) => {
      event.preventDefault();
      if (onSubmit) {
        onSubmit();
      }
    }}
  >
    {children}
  </form>
);
